<template>
	<footer>
		<div class="mobile_footer_container">
			<p class="copyright">ⓒ ONETETHER.ALL Rights Reserved</p>
			<div v-if="0" class="footer_link">
				<ul>
					<li><router-link to @click="notYet">About</router-link></li>
					<li><router-link :to="{ name: 'terms' }">Privacy</router-link></li>
					<li><router-link :to="{ name: 'cookies' }">Cookies</router-link></li>
				</ul>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	name: 'Footer',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
